import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Dropdown, Grid, Label } from 'semantic-ui-react';
import InputField from 'common/InputField';
import { addBlueprint } from 'events/blueprints'


const newBlueprint = function(id, type) {
  return {
    _type: type,
    ID: id,
    Name: 'New ' + type,
    Icon: 1
  };
}

const newScript = function(bp) {
  return { ...bp, FileLua: ''};
}

const newItem = function(bp) {
  return { ...bp,
    Description: '',
    ItemType: 'misc',
    Gold: '0',
    Damage: '',
    Armor: '',
    ArmorPenalty: '',
    Uses: '',
    OnUse: '',
    TargetType: null,
    Identified: true
  };
}

const newMap = function(bp) {
  return { ...bp,
    Tiles: "###\n#.#\n###",
    OnMove: '',
    OnInteract: '',
    Spawn: [],
    Trigger: []
  };
}

const newTrap = function(bp) {
  return { ...bp,
    Spot: '0',
    Disarm: '0',
    OnMove: ''
  };
}

const newSkill = function(bp) {
  return { ...bp,
    Description: '',
    TargetType: 'self',
    RequiredStat: 'STR',
    RequiredValue: '1',
    Cooldown: '1',
    OnUse: '',
    Gain: 'startlevelup'
  };
}

const newSpell = function(bp) {
  return { ...bp,
    Description: '',
    School: 'fire',
    Level: '1',
    TargetType: 'single',
    Cost: '1',
    OnCast: '',
    Gain: 'startlevelup'
  };
}

const newCreature = function(bp) {
  return { ...bp,
    Description: '',
    MaxHP: '4',
    MaxMP: '',
    STR: '',
    DEX: '',
    INT: '',
    WTR: '',
    ERT: '',
    AIR: '',
    FIR: '',
    ATK: '',
    ARC: '',
    DEF: '',
    LOR: '',
    THF: '',
    WOD: '',
    LUK: '',
    AP: '4',
    XP: '0',
    Enemy: true,
    Skill: [],
    Spell: [],
    Item: [],
    Equipment: [],
    OnCreate: '',
    OnCombatRound: '',
    OnDeath: '',
    OnDamaged: '',
    OnInteract: '',
    OnRound: '',
    OnSee: ''
  };
}

const newQuestLog = function(bp) {
  return {...bp,
    Node: []
  };
}

const types = [
  {type: 'Script', init: newScript},
  {type: 'Item', init: newItem},
  {type: 'Map', init: newMap},
  {type: 'Trap', init: newTrap},
  {type: 'Skill', init: newSkill},
  {type: 'Spell', init: newSpell},
  {type: 'Creature', init: newCreature},
  {type: 'QuestLog', init: newQuestLog}
];

const NewBlueprintDialog = function(props) {

  const [ type, setType ] = useState(null);
  const [ id, setId ] = useState('');

  useEffect(() => {
    setType(null);
    setId('');
  }, [props.visible]);

  const options = types.map(t => ({key: t.type, text: t.type, value: t.type }));

  const idIsUnique = !props.blueprints.find((b) => b.ID === id);
  const valid = (id.length >= 4 && idIsUnique && type != null);

  const create = () => {
    if (!valid) return;
    const typeRow = types.find(t => t.type === type);
    const bp = newBlueprint(id, type);
    props.add(typeRow.init(bp));
    props.onClose();
  };

  return (
    <Modal className='new-blueprint-dialog'
           open={props.visible}
           onClose={props.onClose}>
      <Modal.Header>New blueprint</Modal.Header>
      <Modal.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              To create a blueprint you need a unique id for it.
              This id is later used to reference this blueprint from
              other blueprints and/or scripts.
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <InputField label='ID'
                          placeholder='ID'
                          type='id'
                          value={id}
                          autoFocus
                          onChange={setId} />
              <Label>Type</Label>
              <Dropdown options={options}
                        placeholder='Select type'
                        selection
                        search
                        clearable
                        value={type}
                        onChange={(e,d) => setType(d.value)} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button secondary
                     onClick={props.onClose}>Cancel</Button>
              <Button primary
                     disabled={!valid}
                     onClick={create}>Create</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
}

const mapState = function(state) {
  return {
    blueprints: state.module.Blueprints
  }
}

const mapDispatch = function(dispatch) {
  return {
    add: (bp) => dispatch(addBlueprint(bp))
  }
}

const ConnectedNewBlueprintDialog = connect(mapState, mapDispatch)(NewBlueprintDialog);

export default ConnectedNewBlueprintDialog;
